import { Plus, Trash2, X } from "lucide-react";
import { useCollection } from "./useCollection";

const TableEditor = ({ t, i, update, save, remove }) => {
  const setTier = (j, k, v) => update(t.id, "tiers", t.tiers.map((r, n) => (n === j ? { ...r, [k]: v } : r)));
  return (
    <div className="panel space-y-3 p-5" data-testid={`admin-pricing-${i}`}>
      <div className="grid gap-3 sm:grid-cols-2">
        <div><label className="label">Title</label><input className="field" value={t.title} onChange={(e) => update(t.id, "title", e.target.value)} data-testid={`admin-pricing-title-${i}`} /></div>
        <div><label className="label">Column label</label><input className="field" value={t.unit_label} onChange={(e) => update(t.id, "unit_label", e.target.value)} data-testid={`admin-pricing-unit-${i}`} /></div>
      </div>
      <div className="grid grid-cols-[1fr_90px] gap-3">
        <div><label className="label">Subtitle</label><input className="field" value={t.subtitle} onChange={(e) => update(t.id, "subtitle", e.target.value)} data-testid={`admin-pricing-subtitle-${i}`} /></div>
        <div><label className="label">Order</label><input className="field" type="number" value={t.order} onChange={(e) => update(t.id, "order", parseInt(e.target.value, 10) || 0)} /></div>
      </div>
      <p className="label">Quantity tiers</p>
      {t.tiers.map((r, j) => (
        <div key={j} className="flex items-center gap-2">
          <input className="field" value={r.qty} placeholder="1–5" onChange={(e) => setTier(j, "qty", e.target.value)} data-testid={`admin-pricing-${i}-qty-${j}`} />
          <span className="text-slate-500">$</span>
          <input className="field" value={r.price} placeholder="35.00" onChange={(e) => setTier(j, "price", e.target.value)} data-testid={`admin-pricing-${i}-price-${j}`} />
          <button onClick={() => update(t.id, "tiers", t.tiers.filter((_, n) => n !== j))} className="p-2 text-slate-500 hover:text-red-400" data-testid={`admin-pricing-${i}-remove-tier-${j}`}><X className="h-4 w-4" /></button>
        </div>
      ))}
      <button onClick={() => update(t.id, "tiers", [...t.tiers, { qty: "", price: "" }])} className="text-sm text-[#60A5FA]" data-testid={`admin-pricing-${i}-add-tier`}>+ Add tier</button>
      <div className="flex justify-between pt-2">
        <button onClick={() => window.confirm("Delete this price table?") && remove(t.id)} className="flex items-center gap-1 text-sm text-slate-500 hover:text-red-400" data-testid={`admin-pricing-delete-${i}`}><Trash2 className="h-4 w-4" />Delete</button>
        <button onClick={() => save(t)} className="btn-red !py-2 !text-base" data-testid={`admin-pricing-save-${i}`}>Save</button>
      </div>
    </div>
  );
};

export default function PricingAdmin() {
  const { items, setItems, create, save, remove } = useCollection("pricing");
  const update = (id, k, v) => setItems((xs) => xs.map((x) => (x.id === id ? { ...x, [k]: v } : x)));
  return (
    <div>
      <div className="flex flex-wrap items-center justify-between gap-3">
        <h1 className="font-display text-4xl font-black uppercase">Pricing Tables</h1>
        <button className="btn-red !py-2" onClick={() => create({ title: "New Item", subtitle: "", unit_label: "Price Per Item", tiers: [{ qty: "1–5", price: "0.00" }], order: items.length })} data-testid="admin-add-pricing-button"><Plus className="h-4 w-4" />Add Table</button>
      </div>
      <p className="mt-2 text-sm text-slate-400">Bulk banner, notes and gang sheet text live under Site Settings.</p>
      <div className="mt-6 grid gap-5 xl:grid-cols-2">
        {items.map((t, i) => <TableEditor key={t.id} t={t} i={i} update={update} save={save} remove={remove} />)}
      </div>
    </div>
  );
}
